module.exports = __webpack_public_path__ + "media/images/Jollibee-6448e1a9e47fd3770af2373b53001af4.png";